import React, {useState} from "react";
import {Button, Input, Form, Col, Row} from "antd";
import {addOtherRole} from "../../../api";

function AddOtherRoleDialog ({ onClose, setOtherRoles}) {
    const [form] = Form.useForm();
    const [roleName, setRoleName] = useState(null);

    const onNameChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setRoleName(value);
        }
    }
    const onSubmit = async (values) => {
        let response = await addOtherRole(roleName);
        if(response !== null && response.data !== null)
            setOtherRoles(response.data);
        onClose();
    }
    return (
        <div className='react-confirm-alert-body'>
            <h4>{'Add New Role'}</h4>
            <section>
                <Form
                    form={form}
                    style={{ padding: '1rem 1rem' }}
                    onFinish={(values) => onSubmit(values)}
                >
                    <div style={{ top: 15, position: 'relative' }}>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Role Name'
                                    name='roleName'
                                    initialValue={roleName}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter role name!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='roleName'
                                            size='small'
                                            value={roleName}
                                            placeholder='Role Name'
                                            onChange={onNameChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Button
                            className='btn btn-primary start-5'
                            type='primary' htmlType='submit'
                        >
                            Save Changes
                        </Button>
                        <Button className='btn btn-primary start-5' type='primary' onClick={onClose}>
                            Cancel
                        </Button>{' '}
                    </div>
                </Form>
            </section>
        </div>
  )
}

export default AddOtherRoleDialog;